module.exports = __webpack_public_path__ + "images/add_task_app_preview_1_garmin.webp";